import { confirmationAlert, showAlert } from 'utility/SweetAlert'
import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getTranslate } from 'utility/MapperTranslate'
import { getMessage } from 'utility/MapperResponse'

const InteractorCorporateRegionCreate = () => {
  const corporateRegionCreate = useCallback((body, loading) => {
    const payload = {
      ...body,
    }

    confirmationAlert({
      message: getTranslate('message.confirm_process'),
      icon: 'question',
    }).then((result) => {
      if (result === true) {
        ApiService.jsonRequest('/corporate/region/create', payload, (response) => {
          loading(false)
          if (response.code === 7201) {
            showAlert({
              icon: 'success',
              message: getTranslate('message.successfully_created'),
              timer: 2000,
              redirect: '/company/region/manage',
            })
          } else {
            showAlert({
              icon: 'error',
              message: getMessage(response?.msg),
              timer: 2000,
            })
          }
        })
      } else {
        loading(false)
      }
    })
  }, [])
  return { corporateRegionCreate }
}

export default InteractorCorporateRegionCreate
